/**
 * QA: seal constants. These tests assert coherence, never secrecy —
 * QA does not have the motto and does not want it. If these fail, the
 * build is miswired, which is different from "the seal is broken".
 */

import { SEAL_EXPECTED, SEAL_LAUNCH, SEAL_VERSION, sealedMaterial } from "../paywall/entitlements-v3";

export interface TestResult {
  name: string;
  pass: boolean;
  note: string;
}

export function sealConstantTests(): TestResult[] {
  const results: TestResult[] = [];

  results.push({
    name: "seal expected digest is 64 hex chars",
    pass: /^[0-9a-f]{64}$/.test(SEAL_EXPECTED),
    note: "shape only",
  });

  results.push({
    name: "seal launch remains off until legal prints the listing",
    pass: SEAL_LAUNCH === false,
    note: "flip only with the listing in hand",
  });

  results.push({
    name: "seal version is 3",
    pass: SEAL_VERSION === "3",
    note: "v1 retired, v2 was the misfire, v3 current",
  });

  const mat = sealedMaterial();
  results.push({
    name: "sealed payload is present and base64",
    pass: /^[A-Za-z0-9+/=]+$/.test(mat.ct) && mat.ct.length > 128,
    note: `ct ${mat.ct.length} b64 chars, iv ${mat.iv.length}`,
  });

  const prefix = SEAL_EXPECTED.slice(0, 16);
  results.push({
    name: "seal prefix published for QA diffs",
    pass: prefix.length === 16,
    note: `prefix ${prefix}`,
  });

  return results;
}
